import { render, staticRenderFns } from "./iHealthRefundStat.vue?vue&type=template&id=649f92cf&scoped=true&"
import script from "./iHealthRefundStat.vue?vue&type=script&lang=js&"
export * from "./iHealthRefundStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f92cf",
  null
  
)

export default component.exports